import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import AddClientForm from './AddClientForm';
import {
  setLastNameFilter,
  loadClientDataExcel,
 // getExcel,
} from '../../actions/advisor';
import s from './FilterClientForm.css';

class FilterClientForm extends PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      showAddClient: false,
    };
  }

  lastNameFilterChange = (event) => {
    this.props.setLastNameFilter(event.target.value);
  }

  toggleAddClientForm = () => {
    this.setState(Object.assign({}, this.state, {
      showAddClient: !this.state.showAddClient,
    }));
  }

  getExcelDownload = () => {
    this.props.loadClientDataExcel();
  }

  render() {
    return (
      <div>
        <div className="row">
          <div className="col-md-6">
            <div className={'input-group ' + s.filterCol}>
              <div className={s.searchIcon} />
              <input
                onChange={this.lastNameFilterChange}
                type="text"
                className={s.filterField + ' form-control'}
                placeholder="Filter by Last Name"
              />
            </div>
          </div>
          <div className="col-md-4">
            {/* <div className={s.addCol} onClick={this.toggleAddClientForm}>
              <div className={s.addText}>Add Client</div>
              <div className={this.state.showAddClient ? s.closeIcon : s.addIcon}/>
            </div> */}
          </div>
          <div className="col-md-2">
            <button className={s.downloadExcelButton} onClick={this.getExcelDownload}>
              EXPORT
            </button>
          </div>
        </div>
        { this.state.showAddClient &&
          <AddClientForm />
        }
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    lastNameFilter: state.advisorData.lastNameFilter,
    advisorData: state.advisorData,
  };
}

export default connect(mapStateToProps, {
  setLastNameFilter,
  loadClientDataExcel,
 // getExcel,
})(FilterClientForm);




// WEBPACK FOOTER //
// ./src/components/AdvisorMode/FilterClientForm.js